var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLatestUpdateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.32,
    height: 92.052,
    viewBox: "0 0 91.32 92.052",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "latestUpdateIcon",
    d: "M94.822,40.227H60.8l13.75-14.15c-13.7-13.548-35.88-14.05-49.579-.5a34.5,34.5,0,0,0,0,49.124,35.227,35.227,0,0,0,49.579,0A32.68,32.68,0,0,0,84.786,50.162H94.822A46.868,46.868,0,0,1,81.574,81.724a45.436,45.436,0,0,1-63.83,0,44.353,44.353,0,0,1-.1-63.124,45.1,45.1,0,0,1,63.479,0l13.7-14.1ZM52.168,29.589V50.914L69.731,61.351l-3.613,6.072L44.641,54.678V29.589Z",
    transform: "translate(-4.002 -3.268)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatestUpdateIcon);
export default __webpack_public_path__ + "static/media/latestUpdateIcon.1bd86c3a7926b8105a1080f857d06e5b.svg";
export { ForwardRef as ReactComponent };